module.exports = __webpack_public_path__ + "static/media/feedback.f2e98df6.jpg";